import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'SNCheck',
})
export class SNCheckPipe implements PipeTransform {
  transform(value: string | undefined): unknown {
    if (!value || value.trim().length === 0) {
      return '';
    }
    if (value.trim().length > 0) {
      if (value.trim().toLowerCase() === 's') {
        // Return check mark
        return '✔️';
      }
    }
    return null;
  }
}
